(() => {
  const announcementInstances = new Map();
  function initializeAnnouncements(root) {
    root.querySelectorAll('[data-zc-announcement]').forEach(carousel => {
      if (announcementInstances.has(carousel)) return;
      const items = Array.from(carousel.querySelectorAll('[data-zc-announcement-item]'));
      if (items.length < 2) return;
      let index = 0;
      let timer;
      let hovering = false;
      let focused = false;
      let selected = false;
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      const track = carousel.querySelector('.zc-announcement-track');
      const stop = () => { clearTimeout(timer); timer = undefined; };
      const show = (next, manual = false) => {
        index = (next + items.length) % items.length;
        track.setAttribute('aria-live', manual ? 'polite' : 'off');
        items.forEach((item, position) => { item.hidden = position !== index; item.inert = position !== index; });
      };
      const schedule = () => {
        stop();
        if (carousel.dataset.autoplay !== 'true' || hovering || focused || selected || reduced.matches || document.hidden || !carousel.isConnected) return;
        timer = setTimeout(() => { show(index + 1); schedule(); }, Math.max(3000, Number(carousel.dataset.interval) || 5000));
      };
      const manual = delta => { show(index + delta, true); schedule(); };
      carousel.querySelector('[data-zc-announcement-prev]').addEventListener('click', () => manual(-1));
      carousel.querySelector('[data-zc-announcement-next]').addEventListener('click', () => manual(1));
      carousel.addEventListener('mouseenter', () => { hovering = true; stop(); });
      carousel.addEventListener('mouseleave', () => { hovering = false; schedule(); });
      carousel.addEventListener('focusin', () => { focused = true; stop(); });
      carousel.addEventListener('focusout', event => { focused = carousel.contains(event.relatedTarget); schedule(); });
      carousel.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); manual(event.key === 'ArrowLeft' ? -1 : 1); }
      });
      const visibility = () => schedule();
      document.addEventListener('visibilitychange', visibility);
      reduced.addEventListener('change', schedule);
      announcementInstances.set(carousel, { showBlock(id) { selected = true; const next = items.findIndex(item => item.dataset.shopifyEditorBlock && JSON.parse(item.dataset.shopifyEditorBlock).id === id); if (next >= 0) show(next); stop(); }, deselect() { selected = false; schedule(); }, destroy() { stop(); document.removeEventListener('visibilitychange', visibility); reduced.removeEventListener('change', schedule); } });
      schedule();
    });
  }
  const productCarousels = new Map();
  function initializeProductCarousels(root) {
    root.querySelectorAll('[data-zc-products-carousel]').forEach(carousel => {
      if (productCarousels.has(carousel)) return;
      const track = carousel.querySelector('[data-zc-products-track]');
      const previous = carousel.querySelector('[data-zc-products-prev]');
      const next = carousel.querySelector('[data-zc-products-next]');
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      let timer;
      let hovered = false;
      let focused = false;
      const max = () => Math.max(0, track.scrollWidth - track.clientWidth);
      const stop = () => { clearTimeout(timer); timer = undefined; };
      const schedule = () => {
        stop();
        if (carousel.dataset.autoplay !== 'true' || hovered || focused || reduced.matches || document.hidden || max() < 2 || !carousel.isConnected) return;
        timer = setTimeout(() => { move(1); }, Math.max(3000, Number(carousel.dataset.interval) || 5000));
      };
      const move = direction => {
        const first = track.querySelector('.zc-product-tile');
        if (!first || max() < 2) return;
        const stride = first.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0);
        const visible = Math.max(1, Math.round((track.clientWidth + (parseFloat(getComputedStyle(track).columnGap) || 0)) / stride));
        let target = track.scrollLeft + direction * stride * visible;
        if (direction > 0 && track.scrollLeft >= max() - 2) target = 0;
        if (direction < 0 && track.scrollLeft <= 2) target = max();
        track.scrollTo({left: Math.max(0, Math.min(max(), target)), behavior: reduced.matches ? 'instant' : 'smooth'});
        schedule();
      };
      const update = () => { const overflow = max() > 2; previous.hidden = !overflow; next.hidden = !overflow; schedule(); };
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      carousel.addEventListener('mouseenter', () => { hovered = true; stop(); });
      carousel.addEventListener('mouseleave', () => { hovered = false; schedule(); });
      carousel.addEventListener('focusin', () => { focused = true; stop(); });
      carousel.addEventListener('focusout', event => { focused = carousel.contains(event.relatedTarget); schedule(); });
      track.addEventListener('keydown', event => { if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); move(event.key === 'ArrowLeft' ? -1 : 1); } });
      const observer = new ResizeObserver(update);
      observer.observe(track);
      document.addEventListener('visibilitychange', schedule);
      reduced.addEventListener('change', schedule);
      productCarousels.set(carousel, {destroy() { stop(); observer.disconnect(); document.removeEventListener('visibilitychange', schedule); reduced.removeEventListener('change', schedule); }});
      update();
    });
  }
  function initialize(root = document) {
    initializeProductCarousels(root);
    initializeAnnouncements(root);
    root.querySelectorAll('[data-zc-carousel]').forEach(carousel => {
      if (carousel.dataset.zcReady) return;
      carousel.dataset.zcReady = 'true';
      const track = carousel.querySelector('[data-zc-track]');
      const dots = Array.from(carousel.querySelectorAll('[data-zc-index]'));
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
      const current = () => Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
      const move = index => {
        const next = (index + dots.length) % dots.length;
        track.scrollTo({left: next * track.clientWidth, behavior: reduce.matches ? 'instant' : 'smooth'});
      };
      dots.forEach((dot, index) => dot.addEventListener('click', () => move(index)));
      carousel.querySelector('[data-zc-prev]').addEventListener('click', () => move(current() - 1));
      carousel.querySelector('[data-zc-next]').addEventListener('click', () => move(current() + 1));
      track.addEventListener('scroll', () => dots.forEach((dot, index) => dot.setAttribute('aria-pressed', String(index === current()))), {passive: true});
    });
    root.querySelectorAll('.zc-mobile-nav nav a').forEach(link => {
      if (link.dataset.zcReady) return;
      link.dataset.zcReady = 'true';
      link.addEventListener('click', () => link.closest('details').removeAttribute('open'));
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => {
    productCarousels.forEach((instance, element) => { if (event.target.contains(element)) { instance.destroy(); productCarousels.delete(element); } });
    announcementInstances.forEach((instance, element) => { if (event.target.contains(element)) { instance.destroy(); announcementInstances.delete(element); } });
  });
  document.addEventListener('shopify:block:select', event => { announcementInstances.forEach((instance, element) => { if (element.contains(event.target)) instance.showBlock(event.detail.blockId); }); });
  document.addEventListener('shopify:block:deselect', () => announcementInstances.forEach(instance => instance.deselect()));
})();


